export const ENGLISH = { code: 'en', name: 'English' };
export const SPANISH = { code: 'es', name: 'Español' };
export const FRENCH = { code: 'fr', name: 'Français' };
export const CHINESE = { code: 'zh', name: '中文' };
export const KOREAN = { code: 'ko', name: '한국어' };
export const RUSSIAN = { code: 'ru', name: 'Русский' };
export const JAPANESE = { code: 'ja', name: '日本語' };

export default [ENGLISH, SPANISH, FRENCH, CHINESE, KOREAN, RUSSIAN, JAPANESE];
